import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from "@mui/material/Button";
import { MdClose } from "react-icons/md";
import { RiLoginBoxLine } from "react-icons/ri";

function LogResModal ({ modalClose, handleSelectLogin, resourceCount, resourceList }) {

  const [modalHeight, setModalHeight] = useState(120+(Number(resourceCount)*55));
  const [resourceMap, setResourceMap] = useState([]);

  useEffect(() => {
    var array_resource = resourceList.split("▒");
    var resource_map = [];

    for(var i=0; i<resourceCount; i++){
      var tmp_array_resource = (array_resource[i]).split("▦");
      resource_map.push({ id:String(tmp_array_resource[0]), name: String(tmp_array_resource[1])})
    }

    setResourceMap(resource_map);
  }, []);

  return (
    <>
      <BluContainer onClick={modalClose}>
        <BaseContainer style={{ width: '500px', height: modalHeight+'px', overflowY: 'auto' }}>
          <div style={{ display: 'flex', height: '55px' }}>
            <div style={{ float: 'left', width: 'calc(100% - 30px)' }}>
              <p style={{ fontSize: '28px', margin: '0', fontWeight: 'bold' }}>로그인 선택</p>
            </div>
            <div style={{ float: 'right' }}>
              <MdClose size="35" onClick={modalClose} style={{ cursor: "pointer" }} />
            </div>
          </div>
          <div style={{ height: '65px' }}>
            <Button style={{ width: 'calc(100% - 10px)', margin: '5px' }}
                onClick={ ()=> handleSelectLogin("") }
                sx={{  
                  m: 1, 
                  fontSize: 24, 
                  color: "white", 
                  borderColor: "#3D63AE", 
                  backgroundColor: "#3D63AE"
                }} 
                variant="outlined" 
                startIcon={<RiLoginBoxLine />}>
              사용자 로그인
            </Button>
          </div>

          <div>
            {resourceMap.map((resource) => (
            /* <Button style={{ width: 'calc(100% - 10px)', margin: '5px', justifyContent:'flex-start' }} */ 
            <Button style={{ width: 'calc(100% - 10px)', margin: '5px' }}
                onClick={()=> handleSelectLogin(resource.id)}
                sx={{  
                  m: 1, 
                  fontSize: 24, 
                  color: "white", 
                  borderColor: "#DB0000", 
                  backgroundColor: "#DB0000"
                }} 
                variant="outlined" 
                startIcon={<RiLoginBoxLine />}>
              {resource.name}
            </Button>
            ))}
          </div>
      </BaseContainer>
    </BluContainer>
    </>
  );
};
const BluContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  z-index: 1;
`;
const BaseContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  background-color: white;
  z-index: 999;
  padding: 10px 15px;
`;


export default LogResModal;